export const teamData = [
    {
        id: 1,
        name: 'Sarah Johnson',
        role: 'CEO & Founder',
        bio: '15+ years in digital marketing with expertise in growth strategy.'
    },
    {
        id: 2,
        name: 'Michael Chen',
        role: 'Head of SEO',
        bio: 'Former Google analyst with deep technical SEO knowledge.'
    },
    {
        id: 3,
        name: 'Emma Williams',
        role: 'Creative Director',
        bio: 'Award-winning designer passionate about brand storytelling.'
    }
];
